import { render, staticRenderFns } from "./MarketReportsHistory.vue?vue&type=template&id=537820e2&scoped=true&"
import script from "./MarketReportsHistory.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarketReportsHistory.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537820e2",
  null
  
)

export default component.exports